import type { LowEntropyBrowserHints } from '../browserFeatures.types';

/**
 * See https://caniuse.com/webp
 *
 * NOTE: We don't want to mandate high entropy hints for these lookups.
 */
export function supportsWebP(hints: LowEntropyBrowserHints): boolean {
  // Chrome, Chromium, Edge, Opera, Android Internet, Samsung Internet
  const isChromium32 = hints.browsers.find(
    ({ brand, majorVersion }) => (brand === 'Chromium' || brand === 'Chrome') && majorVersion >= 32
  );
  if (isChromium32) return true;

  // Opera Mini
  const isOperaMini = hints.browsers.find(({ brand }) => brand === 'Opera Mini');
  if (isOperaMini) return true;

  // Firefox
  const isFirefox65 = hints.browsers.find(
    ({ brand, majorVersion }) => brand === 'Firefox' && majorVersion >= 65
  );
  if (isFirefox65) return true;

  // Safari
  // NOTE that we ignore Safari14+ on MacOS11+
  const isSafari16 = hints.browsers.find(
    ({ brand, majorVersion }) => brand === 'Safari' && majorVersion >= 16
  );
  if (isSafari16) return true;

  // Others.
  return false;
}
